import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/header.vue'),
      children: [
        {
          path: '/index',
          meta: { requireAuth: false, title: '主页' },
          name: 'index',
          component: () => import('./views/index.vue')
        },
        {
          path: '/pages',
          meta: { requireAuth: false, title: '' },
          name: 'pages',
          component: () => import('./views/body.vue'),
          children: [
            {
              path: '/data',
              meta: { requireAuth: true, title: '主数据维护' },
              name: 'data',
              component: () => import('./components/pages/data.vue')
            },
            {
              path: '/audit',
              meta: { requireAuth: true, title: '审计追踪' },
              name: 'audit',
              component: () => import('./components/pages/audit.vue')
            },
            {
              path: '/report',
              meta: { requireAuth: true, title: '报表' },
              name: 'report',
              component: () => import('./components/pages/report.vue')
            },
            {
              path: '/system',
              meta: { requireAuth: true, title: '系统管理' },
              name: 'system',
              component: () => import('./components/pages/system.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/',
      name: 'login',
      meta: { requireAuth: false, title: 'login' },
      component: () => import('./views/login.vue')
    }
  ]
})
